import { Box, Stack, Chip } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import DisplayErrors from "src/components/display-errors";
import Iconify from "src/components/iconify/iconify";
import TruxFormField from "src/components/inputs/trux-form-field";
import TruxTextField from "src/components/inputs/trux-text-field";
import SimpleDialog from "src/components/simple-dialog";
import { ModelSavingData } from "src/hooks/use-model-saving-data";
import { EldAssetNotification } from "src/models";
import TruxSimpleTextField from "src/components/inputs/trux-simple-text-field";
import { formatDatetimeForPreview } from "src/utils/date-utils";

export function AssetNotificationAction({eldAssetNotificationType}: {eldAssetNotificationType: number}) {
  if (eldAssetNotificationType === 0) {
    return <Chip label="In" color="info" size="small" />;
  }
  if (eldAssetNotificationType === 1) {
    return <Chip label="Out" color="warning" size="small" />;
  }
  return <Chip label="Dormancy" color="error" size="small" />;
}
type EldAssetNotificationModalProps = {
  selectedEldAssetNotificationModel: ModelSavingData<EldAssetNotification>,
  isOpen: boolean,
  setIsOpen: Dispatch<SetStateAction<boolean>>,
  updateEldAssetNotification: VoidFunction,
  timezone: string,
}

export function EldAssetNotificationModal(
  { selectedEldAssetNotificationModel, isOpen, setIsOpen, updateEldAssetNotification, timezone }: EldAssetNotificationModalProps
) {

  return selectedEldAssetNotificationModel.model && <SimpleDialog
    title={selectedEldAssetNotificationModel.isNew ? "New Asset Notification" : "Update Asset Notification"}
    open={isOpen}
    size="medium"
    onCancel={() => {
      setIsOpen(false);
    }}
    onSubmit={updateEldAssetNotification}
    submitDisabled={selectedEldAssetNotificationModel.loading}
    submitButton={selectedEldAssetNotificationModel.isNew ? "New Asset Notification" : "Update Asset Notification"}
    submitButtonIcon={selectedEldAssetNotificationModel.isNew ? <Iconify icon="mingcute:add-line" /> : <Iconify icon="basil:save-solid" />}
    submitButtonColor={selectedEldAssetNotificationModel.isNew ? "success" : "info"}>


    <DisplayErrors savingData={selectedEldAssetNotificationModel} />

    <Stack direction="column" gap={1}>
      <TruxFormField label="Time">
        <TruxSimpleTextField disabled value={formatDatetimeForPreview(selectedEldAssetNotificationModel.model?.notificationTime, timezone)} onChange={() => {}} />
      </TruxFormField>
      <TruxFormField label="Asset">
        <TruxSimpleTextField disabled value={selectedEldAssetNotificationModel.model?.deviceType} onChange={() => {}} />
      </TruxFormField>
      <TruxFormField label="Landmark">
        <TruxSimpleTextField disabled value={selectedEldAssetNotificationModel.model?.eldLandmark.name} onChange={() => {}} />
      </TruxFormField>
      <TruxFormField label="Action">
        <AssetNotificationAction eldAssetNotificationType={selectedEldAssetNotificationModel.model?.eldAssetNotificationType} />
      </TruxFormField>
      <TruxFormField label="Notes">
        <TruxTextField multiline minRows={3} modelSavingData={selectedEldAssetNotificationModel} field="notes" />
      </TruxFormField>
    </Stack>
  </SimpleDialog >
}